import React from "react";
import { ShoppingBag, Users, Package, DollarSign } from "lucide-react";

/**
 * @author
 * @function Dashboard
 **/

const StatCard = ({ title, value, icon: Icon }) => (
  <div className="bg-white rounded-xl shadow-sm border p-5 flex items-center gap-4">
    <div className="p-3 rounded-lg bg-gray-100">
      <Icon className="w-5 h-5 text-gray-700" />
    </div>
    <div>
      <p className="text-sm text-gray-500">{title}</p>
      <p className="text-2xl font-semibold text-gray-900">{value}</p>
    </div>
  </div>
);

const StatusCard = ({ title, status }) => {
  const isOnline = status === "Online";
  return (
    <div className="bg-white rounded-xl shadow-sm border p-5 flex justify-between items-center">
      <div>
        <p className="text-sm text-gray-500">{title}</p>
        <p className="text-lg font-medium text-gray-900">{status}</p>
      </div>
      <span
        className={`px-3 py-1 text-sm rounded-full ${
          isOnline ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
        }`}
      >
        {isOnline ? "Healthy" : "Down"}
      </span>
    </div>
  );
};

export const Dashboard = (props) => {
  return (
    <div className="p-6 space-y-8 bg-gray-50">
      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        <StatCard title="Orders" value="1,248" icon={ShoppingBag} />
        <StatCard title="Users" value="823" icon={Users} />
        <StatCard title="Products" value="156" icon={Package} />
        <StatCard title="Revenue" value="৳ 4,92,300" icon={DollarSign} />
      </div>

      {/* System Status */}
      <div>
        <h2 className="text-lg font-semibold text-gray-800 mb-4">
          System Status
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <StatusCard title="Server Status" status="Online" />
          <StatusCard title="Database Status" status="Online" />
        </div>
      </div>
    </div>
  );
};
